import gsap from "gsap";
import ScrollTrigger from "../components/scrollTrigger";

// AGREGA ANIMACION AL STICKY
export function setStickHandler() {
    let refStick = document.querySelector('.ca-sticky.ca-sticky--activated') as any;
    let innerElmStick = '.ca-sticky__desc, .ca-sticky__image, .ca-sticky__btn'

    gsap.to('.ca-sticky', { duration: 1, scaleX: 1, transformOrigin: 'right' }).then(() => {
        gsap.to(innerElmStick, { duration: 1, opacity: 1 });
    })
}


interface animeButterfly {
    refButterfly: string;
    parentWrapper: string;
    start: {
        rotateZ: number;
        scale?: number;
        translateY?: number | string;
        translateX?: number | string;
        top?: number | string;
        left?: number | string;
        right?: number | string;
        bottom?: number | string;
    };
    end?: {
        duration?: number;
        top?: number | string;
        left?: number | string;
        right?: number | string;
        bottom?: number | string;
    }
}

let defaultParams = {
    refButterfly: 'ca-butterfly',
    parentWrapper: 'body',
    start: { rotateZ: 17, top: 0, left: 0 },
    end: { duration: 4 }
}

// CREA Y ANIMA UNA MARIPOSA
export function animateButterfly({ refButterfly, parentWrapper, start, end }: animeButterfly = defaultParams) {
    const tl = gsap.timeline()

    const appendButterfly = (act: string) => {

        let refParent = document.querySelector(act)
        refParent && refParent.insertAdjacentHTML(
            'beforeend',
            `<div class="ca-butterfly ${refButterfly}">
				<img class="ca-butterfly__left" src="${window.drupalSettings.path.themeUrl}/sources/dist/img/100_years/home/butterfly-left.png" alt="" title=""/>
				<img class="ca-butterfly__right" src="${window.drupalSettings.path.themeUrl}/sources/dist/img/100_years/home/butterfly-right.png" alt="" title=""/>
			</div>`
        )
    }

    appendButterfly(parentWrapper)

    tl.set(`.${refButterfly}`, { ...start });

    ScrollTrigger('center', `.${refButterfly}`, (currentTarget) => {
        tl.to(currentTarget, { duration: .2, rotateY: 70, repeat: -1, yoyo: true });
        tl.to(currentTarget, { duration: 4, opacity: 1, ...end });
        tl.to(currentTarget, {
            duration: .6, rotateY: 0, onComplete: () => {
                tl.pause()
            }
        });
    })
}

export function loadButterflys(page: string) {
    animateButterfly({
        refButterfly: "ca-butterfly-c1",
        parentWrapper: `.ca-container.ca-${page}-container`,
        start: {
            rotateZ: 15,
            scale: 0.7,
            bottom: "40%",
            right: "80%",
        },
        end: {
            duration: 5,
            bottom: "60%",
            right: "70%",
        }
    });

    animateButterfly({
        refButterfly: "ca-butterfly-c2",
        parentWrapper: `.ca-container.ca-${page}-container`,
        start: {
            rotateZ: -20,
            scale: 0.4,
            bottom: "70%",
            left: "80%",
        },
        end: {
            duration: 5,
            bottom: "80%",
            left: "70%",
        }
    });

    animateButterfly({
        refButterfly: "ca-butterfly-c3",
        parentWrapper: `.ca-container.ca-${page}-container`,
        start: {
            rotateZ: 15,
            scale: 0.6,
            bottom: "0%",
            left: "70%",
        },
        end: {
            duration: 4,
            bottom: "15%",
            left: "80%",
        }
    });
}